import {
    Avatar,
    Divider,
    Flex,
    Text,
    ContactGroupIcon,
    Tooltip,
    MenuButton,
    Button,
    MoreIcon,
    EmailIcon,
    Dialog,
    PersonIcon,
    ArchiveIcon,
    CloseIcon,
    Input,
    Dropdown,
    InfoIcon,
} from "@fluentui/react-northstar";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { str_ellipsis } from "../../../utils/functions";
import moment from "moment";
import {
    ArrowRight24Filled,
    ArrowRotateClockwise16Filled,
    Calendar20Filled,
} from "@fluentui/react-icons";
import { Container } from "../../../common/styles";
import EmptyTableData from "../constant/EmptyTableData";
import { useNavigate } from "react-router-dom";

import { useMutation, useQueryClient } from "react-query";
import {
    _archive_offboarding_user,
    relance_offboarding_employee,
} from "../api";
import Toast from "../../../components/Alerts";
import useToast from "../../../hooks/useToast";
import { _changeStatusOnboarding } from "../../../pages/New_Onboarding/api";
import { Controller, FormProvider, useForm } from "react-hook-form";
import ArchivedTextIntoDialog from "../constant/ArchivedTextIntoDialog";
import MenuButtonComponent from "./MenuButtonComponent";

const DynamicUserTable = ({
    users_by_agency,
    activeTab,
    userToDisplayIntoTheTable,
    AgencyId,
}) => {
    const navigate = useNavigate();
    const current_date = moment().format("YYYY-MM-DD");
    const queryClient = useQueryClient();
    const [archiver, setArchiver] = useState(false);
    const menuRef = useRef();
    const methods = useForm({
        defaultValues: {
            startDate: current_date,
            status: "Archivé",
        },
    });
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors, isValid },
    } = methods;

    const [toastConfig, setToastConfig] = useToast();

    const { mutate: relanceEmployee } = useMutation(
        "relance_ofboarding_user",
        (user) => {
            return relance_offboarding_employee(user);
        }
    );

    const relancerEmployee = (user) => {
        relanceEmployee(user, {
            onSuccess: (data) => {
                if (data?.success) {
                    menuRef.current?.closeMenu(); // 👈 Ferme le menu via le ref
                    setToastConfig({
                        visible: true,
                        content: "Relance envoyée avec succès",
                        level: "success",
                    });
                } else {
                    setToastConfig({
                        visible: true,
                        content: data?.message,
                        level: "danger",
                    });
                }
            },
            onError: (error) => {
                setToastConfig({
                    visible: true,
                    content: "Erreur lors de l'envoi de la relance",
                    level: "danger",
                });
            },
        });
    };
    useEffect(() => {
        setArchiver(false);
    }, [activeTab]);

    const {
        mutate: archiveOffboardingUser,
        isLoading: isLoadingMutateArchive,
    } = useMutation("archive_offboarding_user", (user) => {
        return _archive_offboarding_user({ user });
    });

    const inputItems = [
        {
            id: 5,
            header: "Archivé",
        },
    ];

    const onSubmitArchiveProfil = (data, user) => {
        const archivePayloadToBack = {
            datefrom: data.startDate,
            status: 5,
        };

        const formatedStartDate = moment(data.startDate).format("DD/MM/YYYY");

        const isToday = moment(data.startDate).isSame(new Date(), "day");

        archiveOffboardingUser(
            { user, archivePayloadToBack },
            {
                onSuccess: (res) => {
                    if (res?.success) {
                        setArchiver(false);
                        menuRef.current?.closeMenu(); // 👈 Ferme le menu via le ref
                        setToastConfig({
                            visible: true,
                            content: isToday
                                ? "Ce collaborateur a bien été archivé"
                                : `L'archivage de ce collaborateur est programmé et sera effectué le ${formatedStartDate}  `,
                            level: "success",
                        });

                        return;
                    } else {
                        setArchiver(true);
                        setToastConfig({
                            visible: true,
                            content: data?.error,
                            level: "danger",
                        });
                        return;
                    }
                },
                onError: (error) => {
                    setToastConfig({
                        visible: true,
                        content: "Erreur lors de l'envoi de la relance",
                        level: "danger",
                    });
                },
            }
        );
    };
    // archiver le profil formulaire

    const menu = (activeTab, user) => {
        switch (activeTab) {
            case 0:
                return [
                    <FormProvider {...methods}>
                        <Dialog
                            open={archiver}
                            onConfirm={(e) => {
                                e.stopPropagation(); // Arrête la propagation
                                handleSubmit((data) =>
                                    onSubmitArchiveProfil(data, user)
                                )();
                            }}
                            onCancel={(e) => {
                                e.stopPropagation(); // Arrête la propagation
                                reset();
                                return setArchiver(false);
                            }}
                            cancelButton="Annuler"
                            confirmButton={{
                                content: "Archiver le compte",
                                flat: true,
                                loading: isLoadingMutateArchive,
                            }}
                            headerAction={{
                                icon: <CloseIcon />,
                                onClick: (e) => {
                                    e.stopPropagation();
                                    reset();
                                    setArchiver(false);
                                },
                            }}
                            header="Archiver le profil ?"
                            content={
                                <Flex>
                                    {/* badge status */}
                                    <Flex column fill gap="gap.medium">
                                        <Flex fill column>
                                            <Text content="Changement du statut" />
                                            <Flex
                                                vAlign="center"
                                                fill
                                                // space="between"
                                                styles={{ gap: "40px" }}
                                            >
                                                <BadgeStatus hAlign="center">
                                                    <BadgeText content="Offboarding" />
                                                </BadgeStatus>
                                                <ArrowRight24Filled
                                                    style={{
                                                        color: "#C7C7C7",
                                                    }}
                                                />
                                                <Controller
                                                    name="status"
                                                    control={control}
                                                    rules={{
                                                        required:
                                                            "Veuillez sélectionner un statut",
                                                    }}
                                                    render={({
                                                        field: {
                                                            onChange,
                                                            value,
                                                        },
                                                    }) => (
                                                        <Flex column>
                                                            <Dropdown
                                                                required
                                                                positionFixed
                                                                items={
                                                                    inputItems
                                                                }
                                                                value={value}
                                                                placeholder="Choisir un statut dans la liste"
                                                                checkable
                                                                onChange={(
                                                                    _,
                                                                    e
                                                                ) => {
                                                                    return onChange(
                                                                        e.value
                                                                    );
                                                                }}
                                                                getA11ySelectionMessage={{
                                                                    onAdd: (
                                                                        item
                                                                    ) =>
                                                                        `${item} has been selected.`,
                                                                }}
                                                                error={
                                                                    errors.status
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                        </Flex>
                                                    )}
                                                />
                                            </Flex>
                                        </Flex>

                                        {/* start date  */}
                                        <Flex gap="gap.smaller" column>
                                            <Controller
                                                name="startDate"
                                                control={control}
                                                rules={{
                                                    required:
                                                        "Veuillez sélectionner une date",
                                                    validate: (value) => {
                                                        const today = new Date()
                                                            .toISOString()
                                                            .split("T")[0];
                                                        return (
                                                            value >= today ||
                                                            "La date ne peut pas être antérieure à aujourd'hui"
                                                        );
                                                    },
                                                }}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        error,
                                                    },
                                                }) => (
                                                    <Input
                                                        defaultValue={
                                                            current_date
                                                        }
                                                        type="date"
                                                        placeholder="Aujourd'hui"
                                                        label={
                                                            <p>
                                                                À partir de :{" "}
                                                                <span
                                                                    style={{
                                                                        color: "red",
                                                                    }}
                                                                >
                                                                    *
                                                                </span>{" "}
                                                            </p>
                                                        }
                                                        value={value}
                                                        // min={
                                                        //     new Date()
                                                        //         .toISOString()
                                                        //         .split("T")[0]
                                                        // }
                                                        onChange={(e) =>
                                                            onChange(
                                                                e.target.value
                                                            )
                                                        }
                                                        error={
                                                            errors.startDate
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                )}
                                            />
                                        </Flex>
                                        <Flex column fill vAlign="center">
                                            <ArchivedTextIntoDialog />
                                        </Flex>
                                    </Flex>
                                </Flex>
                            }
                            trigger={
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setArchiver(true);
                                    }}
                                    icon={<ArchiveIcon />}
                                    text
                                    styles={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    id="button_archiver_le_compte"
                                    content="Archiver le compte"
                                />
                            }
                        />
                        {/* </form> */}
                    </FormProvider>,
                ];

            case 1:
                return [
                    <Button
                        styles={{
                            width: "160px",
                            display: "flex",
                            justifyContent: "flex-start",
                        }}
                        content={<Text content="Relancer" />}
                        icon={<EmailIcon />}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            return relancerEmployee(user);
                        }}
                        text
                    />,

                    <FormProvider {...methods}>
                        <Dialog
                            open={archiver} // Assurez-vous que `archiver` est bien utilisé ici
                            onConfirm={(e) => {
                                e.stopPropagation(); // Arrête la propagation
                                handleSubmit((data) =>
                                    onSubmitArchiveProfil(data, user)
                                )();
                            }}
                            onCancel={(e) => {
                                e.stopPropagation(); // Arrête la propagation
                                reset();

                                return setArchiver(false);
                            }}
                            cancelButton="Annuler"
                            confirmButton={{
                                content: "Archiver le compte",
                                flat: true,
                                loading: isLoadingMutateArchive,
                            }}
                            headerAction={{
                                icon: <CloseIcon />,
                                onClick: (e) => {
                                    e.stopPropagation();

                                    reset();
                                    setArchiver(false);
                                },
                            }}
                            header="Archiver le profil ?"
                            content={
                                <Flex column fill gap="gap.medium">
                                    <Flex fill column>
                                        <Text content="Changement du statut" />
                                        <Flex
                                            vAlign="center"
                                            fill
                                            // space="between"

                                            styles={{
                                                gap: "40px",
                                            }}
                                        >
                                            <BadgeStatus hAlign="center">
                                                <BadgeText content="Offboarding" />
                                            </BadgeStatus>
                                            <ArrowRight24Filled
                                                style={{
                                                    color: "#C7C7C7",
                                                }}
                                            />
                                            <Controller
                                                name="status"
                                                control={control}
                                                rules={{
                                                    required:
                                                        "Veuillez sélectionner un statut",
                                                }}
                                                render={({
                                                    field: { onChange, value },
                                                }) => (
                                                    <Flex fill column>
                                                        <Dropdown
                                                            fill
                                                            required
                                                            positionFixed
                                                            items={inputItems}
                                                            value={value}
                                                            placeholder="Choisir un statut dans la liste"
                                                            checkable
                                                            onChange={(
                                                                _,
                                                                e
                                                            ) => {
                                                                return onChange(
                                                                    e.value
                                                                );
                                                            }}
                                                            getA11ySelectionMessage={{
                                                                onAdd: (item) =>
                                                                    `${item} has been selected.`,
                                                            }}
                                                            error={
                                                                errors.status
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                    </Flex>
                                                )}
                                            />
                                        </Flex>
                                    </Flex>

                                    {/* start date  */}
                                    <Flex gap="gap.smaller" column>
                                        <Controller
                                            name="startDate"
                                            control={control}
                                            rules={{
                                                required:
                                                    "Veuillez sélectionner une date",
                                                validate: (value) => {
                                                    const today = new Date()
                                                        .toISOString()
                                                        .split("T")[0];
                                                    return (
                                                        value >= today ||
                                                        "La date ne peut pas être antérieure à aujourd'hui"
                                                    );
                                                },
                                            }}
                                            render={({
                                                field: {
                                                    onChange,
                                                    value,
                                                    error,
                                                },
                                            }) => (
                                                <Input
                                                    defaultValue={current_date}
                                                    type="date"
                                                    placeholder="Aujourd'hui"
                                                    label={
                                                        <p>
                                                            À partir de :{" "}
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                }}
                                                            >
                                                                *
                                                            </span>{" "}
                                                        </p>
                                                    }
                                                    value={value}
                                                    // min={
                                                    //     new Date()
                                                    //         .toISOString()
                                                    //         .split("T")[0]
                                                    // }
                                                    onChange={(e, i) =>
                                                        onChange(i.value)
                                                    }
                                                    error={
                                                        errors.startDate
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            )}
                                        />
                                    </Flex>
                                    <Flex column fill vAlign="center">
                                        <ArchivedTextIntoDialog />
                                    </Flex>
                                </Flex>
                            }
                            trigger={
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setArchiver(true);
                                    }}
                                    icon={<ArchiveIcon />}
                                    text
                                    styles={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    id="button_archiver_le_compte"
                                    content="Archiver le compte"
                                />
                            }
                        />
                        {/* </form> */}
                    </FormProvider>,
                ];

            default:
                null;
        }
    };

    const getUsersByTab = () => {
        switch (activeTab) {
            case 0:
                return users_by_agency?.waiting_offboarding_users;
            case 1:
                return users_by_agency?.offboarding_users;
            case 2:
                return users_by_agency?.archived_users;
            default:
                return users_by_agency?.waiting_preonboarding_users;
        }
    };

    const list_users_depending_tab = getUsersByTab(activeTab);

    const usersToMap = userToDisplayIntoTheTable
        ? [userToDisplayIntoTheTable]
        : list_users_depending_tab;

    // const { AgencyId } = useAgency();
    const ToDetailCollaboratorPage = (user, activeTab) => {
        if (activeTab === 2) {
            navigate(
                `/offboarding/archived/${user.id}?tab=${AgencyId}&subtab=${activeTab}`,
                {
                    state: { user, activeTab }, // Passez les données ici
                }
            );
        } else
            navigate(
                `/offboarding/detail/${user.id}?tab=${AgencyId}&subtab=${activeTab}`,
                {
                    state: { user, activeTab, AgencyId }, // Passez les données ici
                }
            );
    };

    return (
        <Container fill>
            <Flex fill column>
                <Toast
                    {...toastConfig}
                    onStatusChange={() =>
                        setToastConfig({
                            visible: false,
                            content: "",
                            level: "danger",
                        })
                    }
                />
                <tbody
                    style={{
                        width: "100%",
                        height: "400px",
                        overflowY: "scroll",
                    }}
                >
                    {usersToMap?.length === 0 && (
                        <EmptyTableData activeTab={activeTab} />
                    )}
                    {usersToMap?.map((user) => {
                        const {
                            name,
                            avatar,
                            department,
                            start_date,
                            probationary_period_end_date,
                            task_count,
                            arrival_date,
                        } = user;
                        return (
                            <Trow
                                onClick={() =>
                                    ToDetailCollaboratorPage(user, activeTab)
                                }
                                key={user?.id}
                            >
                                <TableCell>
                                    <EmployeeInfo
                                        gap="gap.small"
                                        vAlign="center"
                                    >
                                        <Flex>
                                            <Avatar
                                                name={name}
                                                image={avatar}
                                                alt={name}
                                            />
                                        </Flex>
                                        <NameText
                                            content={str_ellipsis({
                                                str: name,
                                                length: 20,
                                            })}
                                        />
                                    </EmployeeInfo>
                                </TableCell>
                                {/* departement */}
                                <Flex hAlign="start">
                                    <Tag
                                        width={180}
                                        content={
                                            <Flex
                                                styles={{
                                                    gap: "4px",
                                                    paddingInline: "8px",
                                                    width: "180px",
                                                }}
                                                vAlign="center"
                                                hAlign="start"
                                            >
                                                <ContactGroupIcon
                                                    styles={{
                                                        color: "#616161",
                                                    }}
                                                />
                                                <Divider
                                                    vertical
                                                    styles={{
                                                        width: "10px",
                                                        height: "20px",
                                                    }}
                                                />
                                                <DepartementName
                                                    content={department.name}
                                                />
                                            </Flex>
                                        }
                                    />
                                </Flex>
                                {/* dates */}
                                <TableCell width={190}>
                                    <Text
                                        content={moment(arrival_date).format(
                                            "DD/MM/YYYY"
                                        )}
                                    />
                                </TableCell>
                                <TableCell width={210}>
                                    <Text
                                        content={
                                            probationary_period_end_date
                                                ? moment(
                                                      probationary_period_end_date
                                                  ).format("DD/MM/YYYY")
                                                : "Non défini"
                                        }
                                    />
                                </TableCell>
                                <TableCell width={200}>
                                    <Tag
                                        width={140}
                                        bgColor="#E8EBFA"
                                        color="#4F52B2"
                                        content={
                                            //
                                            <Flex
                                                hAlign="center"
                                                vAlign="center"
                                                gap="gap.small"
                                                fill
                                            >
                                                <Text
                                                    content={
                                                        activeTab === 0
                                                            ? user?.current_status
                                                            : user
                                                                  ?.offboarding_status
                                                                  ?.status_text
                                                    }
                                                />

                                                {user?.next_status_change && (
                                                    <Tooltip
                                                        subtle={false}
                                                        content={
                                                            <Flex
                                                                gap="gap.smaller"
                                                                column
                                                            >
                                                                <Text
                                                                    content={`Prochain Statut : ${user?.next_status_change?.status}`}
                                                                />
                                                                <Text
                                                                    content={`Date d'effet : ${moment(
                                                                        user
                                                                            ?.next_status_change
                                                                            ?.date
                                                                    ).format(
                                                                        "DD/MM/YYYY"
                                                                    )}`}
                                                                />
                                                            </Flex>
                                                        }
                                                        trigger={
                                                            <ArrowRotateClockwise16Filled />
                                                        }
                                                    />
                                                )}
                                            </Flex>
                                        }
                                    />
                                </TableCell>
                                <TableCell fill width={240}>
                                    <Flex
                                        fill
                                        vAlign="center"
                                        hAlign="end"
                                        gap="gap.large"
                                    >
                                        <Flex hAlign="end">
                                            <TaskCount>{task_count}</TaskCount>
                                        </Flex>
                                        {activeTab === 0 || activeTab === 1 ? (
                                            <MenuButtonComponent
                                                archiver={archiver}
                                                activeTab={activeTab}
                                                menu={menu}
                                                user={user}
                                                ref={menuRef}
                                            />
                                        ) : (
                                            <Text
                                                styles={{ width: "5px" }}
                                                content=""
                                            />
                                        )}
                                    </Flex>
                                </TableCell>
                            </Trow>
                        );
                    })}
                </tbody>
            </Flex>
        </Container>
    );
};
export default DynamicUserTable;

const BadgeText = styled(Text)`
    color: #4f52b2;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
`;

const BadgeStatus = styled(Flex)`
    border-radius: 4px;
    background: #e8ebfa;
    padding: 4px 8px;
`;

const DepartementName = styled(Text)`
    color: #616161;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const Tag = styled(Text)`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: ${({ bgColor }) => bgColor || "#f0f0f0"};
    color: ${({ color }) => color || "#000"};
    font-weight: 700;
    font-size: 12px;
    font-style: normal;
    line-height: 16px;
    width: ${({ width }) => (width ? `${width}px` : "auto")};
`;

const NameText = styled(Text)`
    font-family: Segoe UI;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: nowrap;
    width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
`;

const EmployeeInfo = styled(Flex)`
    width: 200px;
`;
const Trow = styled.tr`
    cursor: pointer;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    &:hover {
        background-color: whitesmoke;
    }
`;

const TableCell = styled.td`
    width: ${({ width }) => (width ? `${width}px` : "245px")};
    padding: 16px;
    /* border-bottom: 1px solid #ddd; */
    vertical-align: middle;
    text-align: center;
    color: #424242;
    font-size: 18px;
    font-style: normal;
    font-weight: ${({ FontWeight }) => (FontWeight ? FontWeight : "400")};
    line-height: 24px;
`;

const TaskCount = styled(Text)`
    background-color: #3d3e78;
    color: white;
    width: 24px;
    height: 24px;
    /* margin-left: 30%; */
    border-radius: 50%;
    padding: 6px 12px;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const InputStyle = styled(Input)`
    width: 196px;
    appearance: none;

    /* Masque l'icône du calendrier pour les navigateurs WebKit (Chrome, Safari) */
    &::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    }
`;
